import { render, staticRenderFns } from "./AllocationDialog.vue?vue&type=template&id=d51e2076&"
import script from "./AllocationDialog.vue?vue&type=script&lang=js&"
export * from "./AllocationDialog.vue?vue&type=script&lang=js&"
import style0 from "./AllocationDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports